import request from '@/service/lib/request'

/**
 * 获取视频播放地址
 * @param {String} url 请求地址
 */
export function getAddress(companyId) {
  return request({
    url: `/api/v1/cameras/address`,
    method: 'get',
    params: { companyId }
  })
}

/**
 * 获取监控截图
 * @param {String} url 请求地址
 */
export function getCover(key) {
  return request({
    url: `/api/v2/cameras/${key}/cover`,
    method: 'get'
  })
}
